/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/* eslint-disable
    default-case
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import React from 'react';

import EditableComponent from 'notebook/mediocre/core-ui/EditableComponent';
import {
  MediocreSearchResultProps,
  forwardSearchResultProps,
} from 'notebook/mediocre/search/SearchResultProps';
import {SelectionRestoreData} from 'notebook/mediocre/selection/SelectionStore';
import * as selutil from 'notebook/mediocre/selection/text/SelUtil';
import getTestProps from 'test/lib/cypress/getTestProps';
import * as keyboard from 'util/Keyboard';

interface Props extends MediocreSearchResultProps {
  cid: string;
  index: number;
  code: string;
  locked: boolean;
  updateHandler: (...args: Array<any>) => any;
  splitHandler: (...args: Array<any>) => any;
  deleteHandler: (...args: Array<any>) => any;
  moveHandler: (...args: Array<any>) => any;
  cursorHandler: (...args: Array<any>) => any;
  tabHandler: (...args: Array<any>) => any;
  setSelectionAbove: (...args: Array<any>) => any;
  setSelectionBelow: (...args: Array<any>) => any;
  insertItemHandler: (...args: Array<any>) => any;
  setClipboard: (...args: Array<any>) => any;
  isLockedWithEditWarn: (...args: Array<any>) => any;
  storeState: (...args: Array<any>) => any;
  restoreState: (...args: Array<any>) => any;
  requestSelection: (selectionRestoreData: {selection: SelectionRestoreData}) => void;
}

class CodeEditable extends React.Component<Props> {
  static hiddenFocusCid(cid: any): string {
    return `${cid}-codeFocus`;
  }

  static defaultProps = {
    code: '',
    locked: false,
  };

  _copyCodeBlockHandler = (e: any): void => {
    // Set plaintext in addition to the html text that @props.setClipboard will take care of
    // This is useful for people who want to paste directly into the terminal
    e.clipboardData.setData('text/plain', this.props.code);
    this.props.setClipboard(this.props.index, e);
    e.preventDefault();
  };

  _cutHandler = (e: any): void => {
    e.preventDefault();
    if (this.props.isLockedWithEditWarn()) {
      return;
    }
    this._copyCodeBlockHandler(e);
    this.props.deleteHandler(this.props.index, {alwaysDelete: true});
  };

  _pasteHandler = ({before, after, selected, originalEvent}: any): void => {
    const copiedText = originalEvent.clipboardData.getData('text/plain');
    const text = before + copiedText + after;
    this.props.updateHandler(this.props.index, {text});

    const pos = before.length + copiedText.length;
    this.props.requestSelection({selection: {cid: this.props.cid, start: pos, end: pos}});
  };

  _hiddenKeyDownHandler = (e: any): void => {
    // Cut and copy will be handled by onCut / onCopy handlers
    if (keyboard.isCtrlX(e) || keyboard.isCtrlC(e)) {
      return;
    }

    // There are no other keyboard interactions that should use the browser default to manipulate the text in
    // the hidden contentEditable.
    e.preventDefault();

    if (keyboard.isUndoRedo(e)) {
      if (!this.props.isLockedWithEditWarn()) {
        if (typeof this.props.restoreState === 'function') {
          this.props.restoreState(e, {selection: selutil.getSelectionIndices()!});
        }
      }
      return;
    }

    // Prevent [backspace, delete, enter] below from modifying if the code block is locked
    if ([8, 46, 13].includes(e.which) && this.props.isLockedWithEditWarn()) {
      return;
    }

    switch (e.which) {
      case 8: // BACKSPACE
        this.props.deleteHandler(this.props.index, {alwaysDelete: true});
        this.props.setSelectionAbove(this.props.index);
        break;
      case 46: // DELETE
        this.props.deleteHandler(this.props.index, {alwaysDelete: true});
        this.props.setSelectionBelow(this.props.index);
        break;
      case 13: {
        // ENTER
        const newIndex = e.shiftKey ? this.props.index - 1 : this.props.index;
        this.props.insertItemHandler(newIndex);
        break;
      }
      case 38: // UP
        if (typeof this.props.moveHandler === 'function') {
          this.props.moveHandler(this.props.index, {up: true, beginning: true});
        }
        break;
      case 40: // DOWN
        if (typeof this.props.moveHandler === 'function') {
          this.props.moveHandler(this.props.index, {up: false, beginning: true});
        }
        break;
      case 37: // LEFT
        if (typeof this.props.cursorHandler === 'function') {
          this.props.cursorHandler(this.props.index, {position: 'start'});
        }
        break;
      case 39: // RIGHT
        if (typeof this.props.cursorHandler === 'function') {
          this.props.cursorHandler(this.props.index, {position: 'end'});
        }
        break;
    }
  };

  override render(): JSX.Element {
    const indentationWidth = 10;
    return (
      <div className="mediocre-codeEditableWrapper">
        <div
          className="hiddenFocusEditable editable"
          data-cid={CodeEditable.hiddenFocusCid(this.props.cid)}
          contentEditable={true}
          onKeyDown={this._hiddenKeyDownHandler}
          onCopy={this._copyCodeBlockHandler}
          onCut={this._cutHandler}
        >
          {null}
        </div>
        <div
          className="mediocre-codeEditable"
          {...getTestProps({component: 'CodeEditable', element: 'root'})}
        >
          <EditableComponent
            style={{marginLeft: indentationWidth}}
            index={this.props.index}
            cid={this.props.cid}
            text={this.props.code}
            allowRichText={false}
            allowMultiline={true}
            locked={this.props.locked}
            dataFormattable={true}
            formats={null}
            storeState={this.props.storeState}
            restoreState={this.props.restoreState}
            // Bind is used just to set the first parameter being called. React will rebind all of these to
            // this anyhow, null is used to stop react from throwing warnings
            updateHandler={this.props.updateHandler.bind(null, this.props.index)}
            splitHandler={this.props.splitHandler.bind(null, this.props.index)}
            mergeUpHandler={this.props.deleteHandler.bind(null, this.props.index)}
            moveHandler={this.props.moveHandler.bind(null, this.props.index)}
            pasteHandler={this._pasteHandler}
            tabHandler={this.props.tabHandler.bind(null, this.props.index)}
            {...forwardSearchResultProps(this.props)}
          />
        </div>
      </div>
    );
  }
}

export default CodeEditable;
